<script setup>
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SocialIcons from '../Social/SocialIcons.vue';

const { t } = useI18n();

const companyDetails = computed(() => usePage().props.company_details);
</script>

<template>
    <p class="mt-8 mb-4 text-xl font-black md:text-2xl md:mt-0">{{ t('Contact') }}</p>

    <div class="grid my-6 gap-y-3">
        <p
            v-if="
                companyDetails.street &&
                companyDetails.postal_code &&
                companyDetails.city &&
                companyDetails.company_name
            "
        >
            {{ companyDetails.company_name }} <br />
            {{ companyDetails.street }} <br />
            {{ companyDetails.postal_code }} {{ companyDetails.city }}
        </p>

        <div class="flex flex-col mb-3">
            <a :href="`tel:${companyDetails.phone_number}`" v-if="companyDetails.phone_number">
                {{ companyDetails.phone_number }}
            </a>

            <a :href="`tel:${companyDetails.email_address}`" v-if="companyDetails.email_address">
                {{ companyDetails.email_address }}
            </a>
        </div>
    </div>

    <SocialIcons />
</template>
